import styled from 'styled-components';
import HR from 'UIComponents/elements/HR';
const WebhookPanelFullWidthHR = styled(HR).withConfig({
  displayName: "WebhookPanelFullWidthHR",
  componentId: "sc-1j1yddw-0"
})(["position:relative;left:-40px;width:460px;"]);
export default WebhookPanelFullWidthHR;